import { render } from "./MessaggioGlobale.vue?vue&type=template&id=4b35c014&scoped=true"
import script from "./MessaggioGlobale.vue?vue&type=script&lang=js"
export * from "./MessaggioGlobale.vue?vue&type=script&lang=js"

import "./MessaggioGlobale.vue?vue&type=style&index=0&id=4b35c014&scoped=true&lang=css"

import exportComponent from "C:\\Users\\diego\\source\\repos\\PoligeoDocumenti\\PoligeoDocumenti\\poligeo-documenti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b35c014"]])

export default __exports__